export default "__VITE_ASSET__108eA986__"